import * as z from 'zod';
import { InternalScheduleFormValues } from './types';
import { schema } from '@forms/helpers';

export const formSchema = z.object({
  forceOverlapping: schema.boolean(),
  forceSpecialty: schema.boolean(),
  taskId: schema.input(),
  foremanId: schema.input(),
  relatedScheduleForemanId: schema.input().optional(),
  confirmed: schema.boolean(),
  startsAt: schema.input(),
  endsAt: schema.input(),
  note: schema.input(),
  actionType: schema.input(),
  status: schema.input(),
  days: schema.number().int().min(1),
  addDays: schema.number().int().min(0),
  skipSaturday: schema.boolean(),
  skipSunday: schema.boolean(),
  pickedDates: z.array(z.string()),
});

export const defaultValues: InternalScheduleFormValues = {
  taskId: '',
  foremanId: '',
  relatedScheduleForemanId: '',
  confirmed: false,
  startsAt: '',
  endsAt: '',
  note: '',
  actionType: '',
  status: '',
  forceOverlapping: false,
  forceSpecialty: false,
  days: 1,
  addDays: 0,
  skipSaturday: false,
  skipSunday: false,
  pickedDates: [],
};

export const MAX_MULTI_DAYS = 365;
